

import {Outlet, Route, Routes, useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect} from "react";
import CreateAccount from "./screens/logIn/CreateAccount";

import VideoController from "../unreal/VideoController";
import {useConfig} from "../config";
import ContentRendererJSX from "./content/ContentRendererJSX";
import { useCommunityContext } from "../context/communityContext";
import {ReservationClientContext, SlsOrdSource, SlsOrdSourceContext, useSlsOrds} from "../data/slsOrdSource";
import ModelClient, {ModelSourceContext, useModels} from "../data/modelSource";
import SlsOrdClient from "../kova/slsordClient";
import {ReservationClient} from "../data/reservationClient";
import MockSlsOrdClient from "../kova/mockSlsOrdClient";
import {CommunityDataLoader} from "./content/CommunityDataLoader";
import LogIn from "./screens/logIn/LogIn";
import LogInSearch from "./screens/logIn/LogInSearch";
import LoginCommunity from "./screens/logIn/LoginCommunity";
import AccountFound from "./screens/logIn/AccountFound";


const CommunityLoader: React.FC<{serverUri:string, salesCenterId:string, favorites: Set<number>, updateFavorites: (favorites:Set<number>) => void}> = (props) => {
    const { serverUri, salesCenterId, favorites, updateFavorites } = props;
    const { communityId } = useParams();
    if (communityId === undefined) throw "Communityid undefined";

    const communityUri = serverUri + communityId + "/";

    const navigate = useNavigate();
    const loc = useLocation();
    console.log(loc.pathname);

    const playIntroVideo = (pathsWithLoopingVideo.includes(loc.pathname) || loc.pathname.startsWith("/login"));

    const {community} = useCommunityContext();



    //const isAvailable = useUnrealStatusCheck();
    //const models = useModels();


    const source = new SlsOrdSource(new SlsOrdClient({serverUri: communityUri}));
    const reservationClient = new ReservationClient({serverUri: communityUri});
    const modelClient = new ModelClient({ serverUri: communityUri });
    const mockSource = new SlsOrdSource(new MockSlsOrdClient());


    return <ReservationClientContext.Provider value={reservationClient}>
        <SlsOrdSourceContext.Provider value={source}>
            <ModelSourceContext.Provider value={modelClient}>
                <CommunityDataLoader><Outlet />
                </CommunityDataLoader>
            </ModelSourceContext.Provider>
        </SlsOrdSourceContext.Provider>
    </ReservationClientContext.Provider>
}


export const CreateAccountWrapper : React.FC<{onCompleteLogin: (communityId:string) => void, onCancel: (communityId:string) => void}> = (props) => {
    let { phone } = useParams();

    const { onCompleteLogin, onCancel } = props;
    if (!phone) phone = '';
    return <CreateAccount searchedPhone={phone} onCompleteLogin={onCompleteLogin} onCancel={onCancel} />
}
const pathsWithLoopingVideo = ["/", "/welcome"];
const VscRoutes: React.FC<{serverUri:string, salesCenterId:string, favorites: Set<number>, updateFavorites: (favorites:Set<number>) => void}> = (props) => {
    const { serverUri, salesCenterId, favorites, updateFavorites } = props;

    const navigate = useNavigate();
    const onSkipLogin = (communityId:string) => { navigate("/" + encodeURIComponent(communityId)); };
    const onCompleteLogin = onSkipLogin;
    const onAccountFound = (communityId:string) => navigate(`/${encodeURIComponent(communityId)}/login/account-found`);
    const onCreateAccount = (communityId:string, phone:string) => {
        navigate(`/${encodeURIComponent(communityId)}/login/create-account/` + encodeURIComponent(phone));
    }
// We already have the sales center and stationId in the routers baseUrl
    return <>


        <Routes>

            <Route index element={<ContentRendererJSX serverUri={serverUri} salesCenterId={salesCenterId} />} />
            <Route path={":communityId/sc/:contentPage"} element={<ContentRendererJSX serverUri={serverUri} salesCenterId={salesCenterId} />}/>
            <Route path={":communityId"} element={<CommunityLoader serverUri={serverUri} salesCenterId={salesCenterId} favorites={favorites} updateFavorites={updateFavorites} />}>

                <Route path={":contentPage/*"} element={<ContentRendererJSX serverUri={serverUri} salesCenterId={salesCenterId} />}/>
                <Route index element={<ContentRendererJSX serverUri={serverUri} salesCenterId={salesCenterId} />}/>


            </Route>


        </Routes></>
}
export default VscRoutes;